import { ReactNode, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Blur } from '../blur/blur';
import { m } from 'framer-motion';

type BspotModalLayoutProps = {
  children?: ReactNode;
  smallLg?: boolean;
  bg: '#121212' | '#000000';
  maxHeight?: string;
};
const BspotModalLayout = ({
  children,
  smallLg = false,
  bg,
  maxHeight,
}: BspotModalLayoutProps) => {
  const desktopSize = smallLg ? 'col-xl-4 col-lg-6' : 'col-xl-8 col-lg-10';
  const [minH, setMinH] = useState('auto');
  useEffect(() => {
    if (maxHeight) {
      setMinH(maxHeight);
    }
  }, [maxHeight]);

  return (
    <div className='d-flex flex-column justify-content-center align-items-center'>
      <div className={'px-lg-0 px-1 col col-12 ' + desktopSize}>
        <div
          className={'d-flex flex-column p-2 gap-2'}
          style={{
            borderRadius: '8px',
            minHeight: minH,
            overflowY: 'auto',
            overflowX: 'hidden',
            width: '100%',
            backgroundColor: bg,
            backgroundImage:
              'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

type BaseModalType = {
  show: boolean;
  children?: ReactNode;
  smallLg?: boolean;
  bg?: '#121212' | '#000000';
  maxHeight?: string;
};

export const BspotModal = ({
  show,
  children,
  smallLg = false,
  bg = '#121212',
  maxHeight,
}: BaseModalType) => {
  useEffect(() => {
    document.querySelector('body').style.overflow = show ? 'hidden' : 'auto';
    return () => {
      document.querySelector('body').style.overflow = 'auto';
    };
  }, [show]);

  return (
    <>
      <Modal
        className='bspot-modal_content'
        overlayClassName={'bspot-modal-overlay'}
        isOpen={show}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
      >
        <BspotModalLayout bg={bg} smallLg={smallLg} maxHeight={maxHeight}>
          {children}
        </BspotModalLayout>
      </Modal>
      <Blur $isVisible={show} />
    </>
  );
};
